// The learner's WhatsApp number (ADO #572): read, save with opt-in, turn off.
//
// normaliseWhatsApp mirrors normalise_whatsapp_number in backend/server.py so
// the Save button can wait for a number the server will accept. The server
// stays the judge: it re-checks and answers 422 with a plain message.
import { authFetch } from '@/services/projectService';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const URL_ME = () => `${API_URL}/api/users/me/whatsapp`;
const INDIAN_MOBILE = /^[6-9]\d{9}$/;

// What the learner typed (the +91 field holds just the local part, but a
// pasted +44… or 0987… works too) → E.164, or null when it isn't a number yet.
export function normaliseWhatsApp(raw) {
  let s = String(raw || '').replace(/[\s\-().]/g, '');
  if (!s) return null;
  if (s.startsWith('+')) {
    const d = s.slice(1);
    if (!/^[1-9]\d{7,14}$/.test(d)) return null;
    if (d.startsWith('91') && !INDIAN_MOBILE.test(d.slice(2))) return null;
    return `+${d}`;
  }
  if (!/^\d+$/.test(s)) return null;
  if (s.length === 11 && s.startsWith('0')) s = s.slice(1);
  else if (s.length === 12 && s.startsWith('91')) s = s.slice(2);
  return INDIAN_MOBILE.test(s) ? `+91${s}` : null;
}

// For the field: "+919876543210" → "9876543210"; other countries keep their +.
export const localPart = (e164) =>
  e164 && e164.startsWith('+91') ? e164.slice(3) : e164 || '';

// { number, opt_in, opt_in_at, opt_out_at }. Throws when the server can't say
// (e.g. migration 447 not applied) so callers can decide not to ask.
export async function getWhatsApp() {
  const res = await authFetch(URL_ME());
  if (!res.ok) throw new Error(`whatsapp ${res.status}`);
  return res.json();
}

async function put(body) {
  const res = await authFetch(URL_ME(), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(typeof json.detail === 'string' ? json.detail : "Couldn't save that. Please try again.");
  }
  return json;
}

export const saveWhatsApp = (number) => put({ number, opt_in: true });
export const stopWhatsApp = () => put({ number: null, opt_in: false });
